import {
    root,
    IAppConfig,
    IManifestServiceRegistryComp,
    IServiceRegistryComponent
} from '@estee/elc-universal-utils';
import { Service } from '../Service';

interface IServiceManifestOptions {
    // name and version are undefined in the manifest as all what is exposed is this interface
    name: string;
    version: string;
    views: string[];
    events?: string[];
    queries?: string[];
}

const defaultManifestOptions = {
    events: [],
    queries: [],
    name: '',
    version: ''
};

type ServiceNamesObject = { [key: string]: string };
interface IServiceLoadFn {
    diContainer: { get: Function };
    serviceNames: ServiceNamesObject;
}
type ServiceLoad = Promise<IServiceLoadFn>;

export const createServiceManifest = <T extends Service>(
    manifestOptions: IServiceManifestOptions,
    serviceLoadFn: () => ServiceLoad,
    serviceKey: string
): IManifestServiceRegistryComp => {
    const options = {
        ...defaultManifestOptions,
        ...manifestOptions,
        isLazy: true,
        isStarted: false,
        isStarting: false
    };

    root.ServiceRegistry = root.ServiceRegistry || {};

    // A service is completely unloaded in the beginning. It's definition
    // consists just of an isLoaded flag, a manifest object detailing what does it
    // offer publicly (queries, events listened for, views) and a method to dynamically load it's core.

    return {
        ...options,
        start: async (appConfig: IAppConfig) => {
            const { diContainer, serviceNames } = await serviceLoadFn();

            const serviceInstance: T = diContainer.get(serviceNames[serviceKey]);
            if (!root.ServiceRegistry[serviceInstance.name].isStarting) {
                serviceInstance.register(options);

                await serviceInstance.start(appConfig || {});
            }
            const serviceFromRoot = root.ServiceRegistry[serviceInstance.name] || serviceInstance;

            return serviceFromRoot as IServiceRegistryComponent;
        }
    };
};
